import controller from './file-viewer.controller';
import template from './file-viewer.html';

/** @type {FileViewer.Bindings} */
const bindings = {
	form:        '<?',
	height:      '@',
	hideCaption: '<?',
	id:          '<?',
	infos:       '<?',
	kid:         '<',
	onError:     '&?',
	url:         '<?',
	viewer:      '@',
	width:       '@',
};

export default {
	template,
	bindings,
	controller,
	controllerAs: '$ctrl',
};
